import { ReactNode } from 'react';

export interface IContainerProps {
  children?: ReactNode;
  visible?: boolean;
  className?: string;
  title?: string;
}

export const Container = ({
  children,
  visible = true,
  className = '',
  title = ''
}: IContainerProps) => {
  if (!visible) return <></>;
  return (
    <div className={className} title={title}>
      {children}
    </div>
  );
};

export default Container;
